import { BaseEvent } from '@features/components/ClinicalData/components/ClinicalLog/components/BaseEvent';
import { LogItemLayout } from '@features/components/ClinicalData/components/ClinicalLog/components/LogItemLayout';
import { ServiceSigner } from '@/api/apis/case';

type ServiceConfirmationItemProps = {
  surgeon?: ServiceSigner;
  managment?: ServiceSigner;
  txApprover?: ServiceSigner;
  shared?: boolean;
};

const FormRow = ({ label, value }: { label: string; value?: string }) => (
  <div className="flex w-full justify-between text-s-r no-wrap">
    <div className="text-base-20">{label}</div>
    <div className="truncate">{value || '---'}</div>
  </div>
);

export const ServiceConfirmationItem = ({ surgeon, managment, txApprover, shared }: ServiceConfirmationItemProps) => {
  return (
    <LogItemLayout>
      <div className="flex w-full flex-col gap-2">
        <BaseEvent event="Service confirmation form" shared={shared} />
        <div className="flex w-full flex-col gap-2">
          <FormRow label="Retrieval Surgery" value={surgeon?.signature?.fullName} />
          <FormRow label="OCS Management" value={managment?.signature?.fullName} />
          <FormRow label="Service Approval" value={txApprover?.signature?.fullName} />
        </div>
      </div>
    </LogItemLayout>
  );
};
